'use client'

import { X24 } from '@vinted/monochrome-icons'
import {
  Button,
  Cell,
  Divider,
  Dialog,
  Navigation,
  Spacer,
  Text,
  BottomSheet,
} from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

import { SERVICE_FEE_HELP_URL } from '../../constants/routes'

type Props = {
  isOpen: boolean
  isOpenedInDialog?: boolean
  onClose: () => void
}

const PartialRefundOfferBuyerProtectionFeeDialog = ({
  isOpen,
  isOpenedInDialog,
  onClose,
}: Props) => {
  const translate = useTranslate('partial_refund_offer_buyer_protection_fee_dialog')
  const { phones } = useBreakpoint()
  const isMobileView = phones && !isOpenedInDialog

  const renderContent = () => {
    return (
      <>
        <Navigation
          body={translate('title')}
          right={
            <Button
              inline
              iconName={X24}
              styling="flat"
              onClick={onClose}
              aria={{ 'aria-label': translate('a11y.close') }}
            />
          }
        />
        <Divider />
        <Cell>
          <Text as="span" text={translate('body')} />
          <Spacer size="large" />
          <a href={SERVICE_FEE_HELP_URL} target="_blank" rel="noreferrer">
            {translate('learn_more')}
          </a>
          {!isMobileView && (
            <>
              <Spacer size="x-large" />
              <Button text={translate('close')} styling="filled" onClick={onClose} />
            </>
          )}
        </Cell>
      </>
    )
  }

  if (isMobileView) {
    return (
      <BottomSheet isVisible={isOpen} onClose={onClose}>
        {renderContent()}
      </BottomSheet>
    )
  }

  return (
    <Dialog show={isOpen} defaultCallback={onClose} closeOnOverlay>
      {renderContent()}
    </Dialog>
  )
}

export default PartialRefundOfferBuyerProtectionFeeDialog
